module.exports = __webpack_public_path__ + "img/ios.7949da16.svg";